import React, { useRef, useEffect, useState } from 'react';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';

import '../../../scss/components/_signal_planning.scss';
import InfoTooltip from './InfoTooltip';

const TrafficTable = props => {

    const [customList, setCustomList] = useState([]);

    useEffect(() => {
        if(props.pedestrianCatalog) {
            setCustomList(props.pedestrianCatalog);
        }
    }, [props.pedestrianCatalog, props.activeData]);

    const gettingPedVolTxt = (val) => {
        let level = "";
        customList.map((item) => {
            if(item['id'] === val) {
                level = item['level'];
            }
        })
        return level;
    }

    return (
        <div className='calc-section'>
            <label>Traffic characteristics 
                <InfoTooltip />
            </label>
            <table cellSpacing={0} className={props.editable ? "editable-table" : null}>
                <tr>
                    <td className='b-bottom b-right-dark odd h-32' width="212px">Approach</td>
                    <td className='b-bottom b-right-dark odd bold-lbl h-32' colSpan={3} width="255px">Northbound</td>
                    <td className='b-bottom b-right-dark odd bold-lbl h-32' colSpan={3} width="255px">Southbound</td>
                    <td className='b-bottom b-right-dark odd bold-lbl h-32' colSpan={3} width="255px">Eastbound</td>
                    <td className='b-bottom odd bold-lbl h-32' colSpan={3} width="255px">Westbound</td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark h-32'>Movement</td>
                    <td className='b-bottom b-right h-32'>Left</td>
                    <td className='b-bottom b-right h-32'>Thru</td>
                    <td className='b-bottom b-right-dark h-32'>Right</td>
                    <td className='b-bottom b-right h-32'>Left</td>
                    <td className='b-bottom b-right h-32'>Thru</td>
                    <td className='b-bottom b-right-dark h-32'>Right</td>
                    <td className='b-bottom b-right h-32'>Left</td>
                    <td className='b-bottom b-right h-32'>Thru</td>
                    <td className='b-bottom b-right-dark h-32'>Right</td>
                    <td className='b-bottom b-right h-32'>Left</td>
                    <td className='b-bottom b-right h-32'>Thru</td>
                    <td className='b-bottom h-32'>Right</td>
                </tr>
                <tr>
                    <td className='odd b-bottom b-right-dark'>Volume</td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'NB', 'Left')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['NB Left'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'NB', 'Thru')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['NB Thru'] : ""} /></td>
                    <td className='editable odd b-bottom b-right-dark'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'NB', 'Right')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['NB Right'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'SB', 'Left')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['SB Left'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'SB', 'Thru')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['SB Thru'] : ""} /></td>
                    <td className='editable odd b-bottom b-right-dark'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'SB', 'Right')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['SB Right'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'EB', 'Left')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['EB Left'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'EB', 'Thru')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['EB Thru'] : ""} /></td>
                    <td className='editable odd b-bottom b-right-dark'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'EB', 'Right')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['EB Right'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'WB', 'Left')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['WB Left'] : ""} /></td>
                    <td className='editable odd b-bottom b-right'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'WB', 'Thru')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['WB Thru'] : ""} /></td>
                    <td className='editable odd b-bottom'><input onChange={(e) => props.handleEdition(e.target.value, 'all_vehicle', 'WB', 'Right')} type='text' value={props.activeData ? props.activeData['peak_15_min_flowrate']['all_vehicle']['WB Right'] : ""} /></td>
                </tr>
                <tr>
                    <td className='b-bottom b-right-dark'>Pedestrians</td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                    {props.editable ? 
                        <Select                  
                            IconComponent={ExpandMoreIcon}
                            MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                            disabled={!props.editable}
                            value={props.activeData ? props.activeData['peak_15_min_flowrate']['pedestrians']['NB Thru'] : ""}
                            onChange={(e) => props.handleEdition(e.target.value, 'pedestrians', 'NB', 'Thru')}
                        >
                            {
                                customList.length > 0  &&
                                customList.map((item) => (
                                    <MenuItem value={item.id}>{item.level}</MenuItem>                        
                                ))
                            } 
                        </Select>
                    :
                    props.activeData ? gettingPedVolTxt(props.activeData['peak_15_min_flowrate']['pedestrians']['NB Thru']) : ""
                    }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData ? props.activeData['peak_15_min_flowrate']['pedestrians']['SB Thru'] : ""}
                                onChange={(e) => props.handleEdition(e.target.value, 'pedestrians', 'SB', 'Thru')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.level}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData ? gettingPedVolTxt(props.activeData['peak_15_min_flowrate']['pedestrians']['SB Thru']) : ""
                        }
                    </td>
                    <td className='editable b-bottom b-right-dark' colSpan={3}>
                        {
                            props.editable ?
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData ? props.activeData['peak_15_min_flowrate']['pedestrians']['EB Thru'] : ""}
                                onChange={(e) => props.handleEdition(e.target.value, 'pedestrians', 'EB', 'Thru')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.level}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData ? gettingPedVolTxt(props.activeData['peak_15_min_flowrate']['pedestrians']['EB Thru']) : ""
                        }
                    </td>
                    <td className='editable b-bottom' colSpan={3}>
                        {
                            props.editable ? 
                            <Select                  
                                IconComponent={ExpandMoreIcon}
                                MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                disabled={!props.editable}
                                value={props.activeData ? props.activeData['peak_15_min_flowrate']['pedestrians']['WB Thru'] : ""}
                                onChange={(e) => props.handleEdition(e.target.value, 'pedestrians', 'WB', 'Thru')}
                            >
                                {
                                    customList.length > 0  &&
                                    customList.map((item) => (
                                        <MenuItem value={item.id}>{item.level}</MenuItem>                        
                                    ))
                                } 
                            </Select>
                            :
                            props.activeData ? gettingPedVolTxt(props.activeData['peak_15_min_flowrate']['pedestrians']['WB Thru']) : ""
                        }
                    </td>
                </tr>
                <tr>
                    <td className='odd b-bottom b-right-dark'>% Heavy vehicles</td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'NB', 'Left')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['NB Left']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'NB', 'Thru')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['NB Thru']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right-dark'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'NB', 'Right')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['NB Right']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'SB', 'Left')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['SB Left']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'SB', 'Thru')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['SB Thru']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right-dark'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'SB', 'Right')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['SB Right']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'EB', 'Left')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['EB Left']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'EB', 'Thru')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['EB Thru']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right-dark'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'EB', 'Right')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['EB Right']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'WB', 'Left')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['WB Left']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom b-right'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'WB', 'Thru')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['WB Thru']*100,0)+"%" : 0} /></td>
                    <td className='editable odd b-bottom'>
                        <input type='text' onChange={(e) => props.handleEdition(e.target.value, 'heavy_trucks', 'WB', 'Right')} value={props.activeData ? Math.round(props.activeData['peak_15_min_flowrate']['heavy_trucks']['WB Right']*100,0)+"%" : 0} /></td>
                </tr>
            </table>
        </div>
    )

}

export default TrafficTable;